module.exports = __webpack_public_path__ + "static/media/acmg-cert-form.2156fc58.png";